import { useNavigate } from 'react-router-dom';
import HomeScreenButton from '../atoms/HomeScreenButton';
import { HomeScreenButtonConfig, HomeScreenButtonProps } from '../atoms/HomeScreenButton.types';

const QuickHelpHomeScreenButton = ({ customLabel, customIcon }: HomeScreenButtonConfig) => {
    const navigate = useNavigate();

    const buttonProps: HomeScreenButtonProps = {
        label: customLabel || 'Schnelle Hilfe',
        iconPath: 'pregnant-less-intense.png',
        customIconSvg: customIcon
    };

    return (
        <HomeScreenButton
            buttonProps={buttonProps}
            action={() => navigate('quick-help')}
            isHidden={false}
            disabled={false}
        />
    );
};
export default QuickHelpHomeScreenButton;